import {useSelector} from 'react-redux'
import {PageTitle, ResponsivePageTitle} from '../../components/core/title'
import text from './text.json'
import classNames from 'classnames'
import Footer from '../../components/layouts/footer'

const LogsFilteredView = () => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <main
            className={classNames('main', {
                dark: isDarkMode
            })}
            id="log-management-logs"
        >
            <div>
                <ResponsivePageTitle/>
                <div className="content-title">
                    <div className="left-side">
                        <div>
                            <PageTitle>
                                <h1
                                    className={classNames('page-title', {
                                        dark: isDarkMode
                                    })}
                                >
                                    {text.title}
                                </h1>
                            </PageTitle>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </main>
    )
}

export default LogsFilteredView
